import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import "./About.scss";
import AboutImage from "../../assets/img/Profile.png";
import { useLocation } from "react-router-dom";
import Snowfall from "react-snowfall";
import Typist from "react-typist";
import { ReactHeight } from "react-height";
import GlowingImage from "../../GlowingImage";

const About: React.FC = () => {
  const imgEl = useRef<HTMLImageElement>(null);
  const location = useLocation();

  const [loaded, setLoaded] = useState(false);
  const onImageLoaded = () => setLoaded(true);

  useEffect(() => {
    const imgElCurrent = imgEl.current;

    if (imgElCurrent) {
      imgElCurrent.addEventListener("load", onImageLoaded);
      return () => imgElCurrent.removeEventListener("load", onImageLoaded);
    }
  }, [imgEl]);
  return (
    <div className="section">
      {/* <img src={circleImg} alt="" className="roundCircle" /> */}
      <div className="about" style={{ height: window.innerHeight }}>
        {/* Left Section */}
        <ReactHeight
          onHeightReady={(height) =>
            console.log("Real About Left Height:++ ", height)
          }
        >
          <section className="about__section-left">
            <div className="about__section-left--intro">
              <div className="about__section-left--intro__top">
                <div></div>
                <p>HELLO</p>
              </div>
              {/* <Typist.Delay ms={500} /> */}
              {location.hash === "#about" || location.hash === "" ? (
                <>
                  <Typist
                    cursor={{
                      show: true,
                      blink: true,
                      hideWhenDone: true,
                      hideWhenDoneDelay: 1000,
                    }}
                    className="about__section-left--intro__name"
                  >
                    I'm <span>Joshua</span> Nwakwuo
                  </Typist>
                  <Typist
                    className="brief"
                    cursor={{
                      show: true,
                      blink: true,
                      hideWhenDone: true,
                      hideWhenDoneDelay: 1000,
                    }}
                    onTypingDone={() => console.log("Happy everyone")}
                  >
                    <Typist.Delay ms={2000} />
                    An <span>Innovative & Creative Software Developer</span>,
                    using my skills and initiative necessary to anticipate needs
                    and bring good new ideas to the world of technology
                  </Typist>
                </>
              ) : (
                <>
                  <h1>
                    I'm <span>Joshua</span> Nwakwuo
                  </h1>

                  <p className="brief">
                    An <span>Innovative Software Developer</span>, using the
                    skills and initiative necessary to anticipate needs and
                    bring good new ideas to the world of technology
                  </p>
                </>
              )}
              <div className="about__section-left--intro__bottom">
                <button
                  className="btn btn-left"
                  style={{
                    backgroundColor: "var(--color-text)",
                  }}
                  type="submit"
                >
                  <a target="_blank" href="https://github.com/joshmatjjen">
                    Git Project&nbsp;<i><Icon icon="simple-icons:github" /></i>
                  </a>
                </button>
                <button
                  style={{
                    backgroundColor: "var(--color-secondary3)",
                  }}
                  className="btn btn-right"
                  type="submit"
                >
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/in/joshmatjjen"
                    style={{ color: "var(--color-bg);" }}
                    rel="noreferrer"
                  >
                    Lets's connect&nbsp;<i><Icon icon="simple-icons:linkedin" /></i>
                  </a>
                </button>
                <div></div>
              </div>
            </div>
          </section>
        </ReactHeight>

        {/* Right Section */}
        <ReactHeight
          onHeightReady={(height) =>
            console.log("Real About Left Height:++ ", height)
          }
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <GlowingImage />
          </div>
          {/*<section className="about__section-right">

             <div className="about__section-right__item">
              <img ref={imgEl} src={AboutImage} alt="" />
              {loaded && <>
              <div className="hexagon">
                <div
                  className="hexagon__item"
                  style={{ animationDelay: "0s" }}
                ></div>
              </div>
              <div className="hexagon">
                <div
                  className="hexagon__item"
                  style={{ animationDelay: "2s" }}
                ></div>
              </div>
              <div className="hexagon">
                <div
                  className="hexagon__item"
                  style={{ animationDelay: "4s" }}
                ></div>
              </div>
              <div className="hexagon">
                <div
                  className="hexagon__item"
                  style={{ animationDelay: "6s" }}
                ></div>
              </div>
              </>}
            </div>
          </section> */}
        </ReactHeight>
        {/* <section className="about__c-container">
          <div className="about__c-container__item">
            <img src={AboutImage} alt="" />
          </div>
          {/* <div id="hexagon"></div> 
          <div
            className="about__c-container__circle"
            style={{ animationDelay: "0s" }}
          ></div>
          <div
            className="about__c-container__circle"
            style={{ animationDelay: "1s" }}
          ></div>
          <div
            className="about__c-container__circle"
            style={{ animationDelay: "2s" }}
          ></div>
          <div
            className="about__c-container__circle"
            style={{ animationDelay: "3s" }}
          ></div>
        </section> */}
      </div>
      <div className="mouseScroll">
        <i className="mouse-icon"><Icon icon="ph:mouse-simple" /></i>
      </div>
    </div>
  );
};

export default About;
